import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import NumberInput from '../../ComponentLibrary/input-elements/oc-numeric-input';

const SuffixInputContainer = styled.div`
  position: relative;

  input {
    padding-right: 25px;
    max-height: 48px;
  }

  span {
    position: absolute;
    right: 8px;
    bottom: 16px;
    color: ${props => (props.touched && !props.valid ? '#940420' : 'rgba(88, 88, 88, 1)')};
    font-size: 16px;
  }
`;

const SuffixInput = ({ suffix, required, name, onChange, value, placeholder, valid, touched }) => (
  <SuffixInputContainer data-testid="suffix-input" suffix={suffix} valid={valid} touched={touched}>
    <NumberInput
      required={required}
      name={name}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      valid={valid}
      touched={touched}
    />
    {suffix && <span data-testid="suffix-content">{suffix}</span>}
  </SuffixInputContainer>
);

SuffixInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  suffix: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  valid: PropTypes.bool,
  touched: PropTypes.bool,
};

SuffixInput.defaultProps = {
  required: false,
  name: '',
  suffix: '',
  placeholder: '',
  valid: true,
  touched: false,
};

export default SuffixInput;
